import React from 'react'
import { Container, Col, Row, Image } from "react-bootstrap";
import  work from '../../../Assets/images/cultbrilliance/calltoday.jpg'
// import { LuDot } from "react-icons/lu";
import { BsDot } from "react-icons/bs";
const HowItWorks = () => {
  return (
   <>
   <section className='cbr_how_it_work'>
   <Container fluid>
   <Row>
    <Col md={12} lg={6} sm={12} className='how-img'>
        <div className='cbr_work_img'>   
     <img src={work} className='img-fluid' alt='How it works:' />
     </div>
    </Col>
    <Col   md={12} lg={6} sm={12} className='without-back' >
    <div className='cbr_how_content'>
    <h3>How it works:</h3>
    <ul className="listih">
                        <li>1.Contact the CB Concierge to submit proof of your active or retired military, police, fire or other first responder status.</li>
                        <li>2.View our jewelry selection online and then work with our CB Concierge to finalize your selection. The CB Concierge is totally free and can assist you with stone and metal selection, sizing, pricing and any other questions you have!</li>
                        <li>3. Apply your savings:
                            <ul className="listih1 doylost">
                                <li> <BsDot />First time purchase: Engagement Rings 5% off center stone plus 15% off mounting OR</li>
                                <li> <BsDot /> 15% off in-store jewelry. (maximum discount $500).</li>
                                <li> <BsDot /> Future Purchase (Other than center stones): 10% off purchase (maximum discount $500).</li>
                            </ul>
                        </li>
                    </ul>
        <p>Diamond Elite discount is valid towards purchase as described here. Not Valid for Previous purchases, 
            gift certificates, repairs, or loose diamonds. Cannot be combined with other promotions or specials. 
            See store for contact us for details.</p>
    </div>
    </Col>
    </Row>
   </Container>
   </section>
   </>
  )
}

export default HowItWorks
